.summary {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: start;
  background: linear-gradient(180deg, rgba(54, 53, 49, 0.96), rgba(34, 34, 32, 0.97));
}

.summary > span:first-child,
.note {
  grid-column: 1 / -1;
}

.group {
  padding: 0.45rem;
  border: 1px solid #24231f;
  background: rgba(17, 17, 16, 0.28);
}

.group h2 {
  margin: 0 0 0.45rem;
  color: #d6c790;
  font-family: Georgia, serif;
  font-size: 0.92rem;
  font-weight: normal;
}

.group ul {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.none {
  color: #8f8c83;
  font-style: italic;
}

.vesselRow {
  display: grid;
  grid-template-columns: 1rem 1fr auto;
  align-items: center;
  gap: 0.35rem;
  color: #ddd7c7;
}

.vesselRow strong {
  color: #cdb975;
  font-weight: normal;
}

.note {
  color: #9f9b90;
  font-size: 0.72rem;
  line-height: 1.35;
}
